import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {AuthService} from '../../auth/shared/services/auth.service';
import {UserInfoQuery} from '../elf-store/user-info/user-info.query';
import {AmplitudeService} from '../../services/amplitude.service';
import {AmplitudeQuery} from '../elf-store/amplitude/amplitude.query';

@Injectable({
  providedIn: 'root',
})
export class UserAuthGuard {
  private userInfoSubscription;

  constructor(
    private auth: AuthService,
    private router: Router,
    private userInfo: UserInfoQuery,
    private ampliService: AmplitudeService,
    private amplitudeQuery: AmplitudeQuery,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.auth.isUserAuthenticated()) {
      this.setIdentityToAmplitute();

      return of(true);
    } else {
      this.auth.userLogOut(false);

      const path = state.url.split('?')[0];
      localStorage.setItem('uw-after-login-redirect', path);
      this.router.navigate(['/login'], {queryParams: route.queryParams});
      this.userInfoSubscription?.unsubscribe();
      return of(false);
    }
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(childRoute, state);
  }

  private setIdentityToAmplitute() {
    if (!this.amplitudeQuery.isIdentitySet) {
      this.userInfoSubscription = this.userInfo.userInfo$.subscribe(userInfo => {
        if (userInfo.id) {
          this.ampliService.identify(userInfo.id, {email: userInfo.email});
        }
      });
    }
  }
}
